import React, { useEffect, useRef, useState } from "react";

export default function DateRangeFilter({
  fromValue,
  toValue,
  onFromChange,
  onToChange,
  label = "Date range",
  fromLabel = "From",
  toLabel = "To",
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!wrapperRef.current?.contains(event.target)) setOpen(false);
    };

    document.addEventListener("pointerdown", closeOnOutsideClick);
    return () => document.removeEventListener("pointerdown", closeOnOutsideClick);
  }, []);

  const summary =
    fromValue && toValue
      ? `${fromValue} to ${toValue}`
      : fromValue
        ? `From ${fromValue}`
        : toValue
          ? `Through ${toValue}`
          : label;

  return (
    <div className="nw-date-range-filter" ref={wrapperRef}>
      <button
        type="button"
        className={`nw-date-range-filter__toggle ${open ? "open" : ""}`}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <span className="nw-date-range-filter__summary">
          <i className="fa-regular fa-calendar" aria-hidden="true" />
          <span>{summary}</span>
        </span>
        <i className="fa-solid fa-chevron-down" aria-hidden="true" />
      </button>

      {open && (
        <div className="nw-date-range-filter__panel" role="dialog" aria-label={label}>
          <div className="nw-date-range-filter__fields">
            <label>
              <span>{fromLabel}</span>
              <input
                type="date"
                className="form-control"
                value={fromValue}
                max={toValue || undefined}
                onChange={(event) => onFromChange(event.target.value)}
              />
            </label>
            <label>
              <span>{toLabel}</span>
              <input
                type="date"
                className="form-control"
                value={toValue}
                min={fromValue || undefined}
                onChange={(event) => onToChange(event.target.value)}
              />
            </label>
          </div>
          <div className="nw-date-range-filter__actions">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              disabled={!fromValue && !toValue}
              onClick={() => {
                onFromChange("");
                onToChange("");
              }}
            >
              Clear
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => setOpen(false)}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
